






























import TheCategoryList from "@/general/components/organisms/sideMenu/TheCategoryList.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconRanking from "@/common/components/icons/IconRanking.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import { mapState } from "vuex";

@Component({
  components: {
    TheCategoryList,
    IconBase,
    IconRanking
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheSideMenu extends Vue {
  @Prop({ type: Array, required: true }) categories!: any;
  @Prop({ type: Boolean, required: false, default: false }) link!: boolean;
  @Prop({ type: Boolean, required: false, default: true }) isShowCat!: boolean;

  clickOnSubcategory(id: number) {
    this.$emit("click-subcategory", id);
  }
}
